import { FaRegCheckCircle } from "react-icons/fa";

export default function OnSuccess({ message, details, onDone, className = "" }) {
  return (
    <div className={`d-flex justify-content-center py-4 ${className}`}>
      <div className="card border-0 rounded-4 shadow-sm" style={{ maxWidth: 560 }}>
        <div className="card-body text-center p-4 p-sm-5">
          <FaRegCheckCircle
            className="text-success mb-3"
            style={{ fontSize: "4.5rem" }} 
            aria-hidden="true"
          />
          <h4 className="fw-bold text-body-emphasis mb-2">{message}</h4>
          {details && (
            <p className="text-body-secondary mb-4 fs-6">
              {details}
            </p>
          )}
          <button type="button" className="btn btn-success px-4" onClick={onDone}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
